// @ts-nocheck
// This file is generated by Umi automatically
// DO NOT CHANGE IT MANUALLY!
import DashboardOutlined from '/Users/maggie/Documents/workspace/fiance/myapp/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/DashboardOutlined';
import TableOutlined from '/Users/maggie/Documents/workspace/fiance/myapp/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/TableOutlined';
import UserOutlined from '/Users/maggie/Documents/workspace/fiance/myapp/node_modules/@umijs/plugins/node_modules/@ant-design/icons/es/icons/UserOutlined';
export default { DashboardOutlined, TableOutlined, UserOutlined };
